import { Injectable, ErrorHandler } from '@angular/core';
import { LoggingService } from './services/logging-service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  constructor(private loggingService: LoggingService) {
    super();
  }

  handleError(error: Error) {
    console.error(error);
    this.loggingService.logException(error);
  }
}
